import {useQuery, useMutation, useQueryClient} from "react-query";
import {ASSET_DATA, ASSET_GITHUB_MAPPING, COMPANY_INTEGRATIONS, INTEGRATION_CONFIG_DETAILS, INTEGRATION_DETAILS} from "./utils/constants";
import axios from "axios";
import { externalIntegrations } from "../utils/constants";

export const useIntegrations = () => {
  return useQuery([COMPANY_INTEGRATIONS, {}], async () => {
      let res = await axios.get(`/integrations`)
      return res.data
  })
}

export const useUpdateIntegration = () => {
  return useMutation(
      async (data) => {
          let res = await axios.put(`/integrations`, data);
          return res.data;
      }
  );
};

/**
 * @param {string} provider
 * @param {{ enabled?: boolean }} [options] — set `enabled: false` to skip `/integrations/details` (e.g. external assets do not need OpenVPN profiles).
 */
export const useIntegrationDetails = (provider, options = {}) => {
  const { enabled: enabledOption = true, ...queryOptions } = options;
  const enabled =
    Boolean(enabledOption) && provider != null && String(provider).trim() !== '';

  return useQuery(
    [INTEGRATION_DETAILS, provider],
    async () => {
      let res = await axios.get(`/integrations/details?provider=${provider}`);
      return res.data;
    },
    {
      ...queryOptions,
      enabled,
    }
  );
};

export const useCreateStatusMapping = () => {
  const queryClient = useQueryClient()
  return useMutation(async (data) => {
    let res = await axios.post(`/integrations/status-mapping`, data);
    return res.data;
  }, {
    onSuccess: async () => {
        await queryClient.invalidateQueries(ASSET_GITHUB_MAPPING)
    },
  });
};

export const useStatusMappingMapping = (assetId) => {
  return useQuery([ASSET_GITHUB_MAPPING, assetId], async () => {
    let res = await axios.get(`/integrations/status-mapping/${assetId}`);
    return res.data;
  });
};

export const getIntegrationResources = async (options) => {
  let queryParams = Object.keys(options)
    .map(key => `${key}=${options[key]}`)
    .join('&');
  let res = await axios.get(`/integrations/resources?${queryParams}`);
  return res.data;
}

export const useCreateIntegration = (options) => {
  const queryClient = useQueryClient();
  return useMutation(
      async (data) => {
          let res = await axios.post(`/integrations`, data, {
              headers: {
                  'Content-Type': 'multipart/form-data', // Set the content type as multipart/form-data
              },
          });
          return res.data;
      },
      options,
      {
          onSuccess: async () => {
              await queryClient.invalidateQueries(INTEGRATION_DETAILS);
          },
      }
  );
};

export const useSingleIntegrationDetails = (integrationId, options = {}) => {
  return useQuery(
    [INTEGRATION_CONFIG_DETAILS, integrationId],
    async () => {
      let res = await axios.get(`/integrations/${integrationId}`);
      return res.data;
    },
    {
      enabled: integrationId !== null && integrationId !== undefined && integrationId !== '',
      ...options,
    }
  );
}

export const deleteIntegration = async (integrationId) => {
  await axios.delete(`/integrations/${integrationId}`);
};

export const useUnlinkAsset = async (assetId) => {
  const queryClient = useQueryClient();
  return useMutation(async () => {
      let res = await axios.put(`/integrations/unlink-asset/${assetId}`);
      return res.data
    }, {
    onSuccess: async () => {
        await queryClient.invalidateQueries(ASSET_DATA);
        await queryClient.invalidateQueries(ASSET_GITHUB_MAPPING);
    },
  })
}

export const useCreateGithubIntegration = () => {
  return useMutation(
      async (data) => {
          let res = await axios.post(`/integrations/github`, data);
          return res.data;
      }
  );
};